import { cva } from 'class-variance-authority'

export const dateStyles = cva(
  `
    text-right
    text-xs
    font-medium
  `,
  {
    variants: {
      state: {
        completed: 'text-green-500',
        upcoming: 'text-blue-500',
        overdue: 'text-red-500',
        warning: 'text-orange-500',
      },
    },
    defaultVariants: {
      state: 'warning',
    },
  }
)

export const cardStyles = cva(
  `
    rounded-xl
    my-0
    mb-2
    group
    hover:bg-white
    hover:outline
    hover:outline-1
    hover:outline-[#1d1d1d]
    cursor-pointer
    border-none
    transition-colors
    duration-400
    hover:shadow-none
    hover:transform-none
  `
)
